module.exports = __webpack_public_path__ + "img/menuboard-cho-express-small.1951f6ed.webp";